// Mismo límite que el PushMenu de la barra superior y los estilos del panel.
export const MOBILE_MENU_QUERY = "(max-width: 991.98px)";

export default function attachMobileMenu(sidebar, onOpenChange) {
  const media = window.matchMedia(MOBILE_MENU_QUERY);
  const body = document.body;
  let wasOpen = false;
  let destroyed = false;
  const toggleButton = () => document.querySelector('[data-widget="pushmenu"]');

  const sync = () => {
    const open = media.matches && body.classList.contains("sidebar-open");
    body.classList.toggle("hemolife-mobile-menu-open", open);
    const toggle = toggleButton();
    if (toggle) {
      toggle.setAttribute("aria-expanded", String(media.matches ? open : !body.classList.contains("sidebar-collapse")));
    }
    onOpenChange(open);
    if (open && !wasOpen) {
      Promise.resolve().then(() => {
        if (!destroyed && media.matches && body.classList.contains("sidebar-open")) {
          const close = sidebar.querySelector(".hemolife-menu-close");
          if (close) close.focus({ preventScroll: true });
        }
      });
    }
    wasOpen = open;
  };

  const close = (restoreFocus = false) => {
    if (!media.matches) return;
    const toggle = toggleButton();
    if (toggle && window.jQuery && window.jQuery.fn.PushMenu) {
      window.jQuery(toggle).PushMenu("collapse");
    }
    // También funciona cuando Vue monta el menú antes de cargar AdminLTE.
    body.classList.remove("sidebar-open", "sidebar-is-opening");
    body.classList.add("sidebar-collapse", "sidebar-closed");
    sync();
    if (restoreFocus && toggle) toggle.focus({ preventScroll: true });
  };

  const onMediaChange = () => {
    if (media.matches) close();
    else {
      body.classList.remove("sidebar-open");
      sync();
    }
  };

  const onKeydown = (event) => {
    if (!media.matches || !body.classList.contains("sidebar-open")) return;
    if (event.key === "Escape") {
      event.preventDefault();
      close(true);
    } else if (event.key === "Tab") {
      const elements = Array.from(sidebar.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex="0"]'))
        .filter((element) => element.getClientRects().length);
      const first = elements[0];
      const last = elements[elements.length - 1];
      if (!first) return;
      if (event.shiftKey && (document.activeElement === first || !sidebar.contains(document.activeElement))) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && (document.activeElement === last || !sidebar.contains(document.activeElement))) {
        event.preventDefault();
        first.focus();
      }
    }
  };

  const observer = new MutationObserver(sync);
  observer.observe(body, { attributes: true, attributeFilter: ["class"] });
  if (media.addEventListener) media.addEventListener("change", onMediaChange);
  else media.addListener(onMediaChange);
  document.addEventListener("keydown", onKeydown);
  onMediaChange();

  return {
    close,
    destroy() {
      destroyed = true;
      observer.disconnect();
      if (media.removeEventListener) media.removeEventListener("change", onMediaChange);
      else media.removeListener(onMediaChange);
      document.removeEventListener("keydown", onKeydown);
      body.classList.remove("hemolife-mobile-menu-open");
    },
  };
}
